import { render, staticRenderFns } from "./AddPessoa.vue?vue&type=template&id=0ab43990"
import script from "./AddPessoa.vue?vue&type=script&lang=js"
export * from "./AddPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports